import React, { Component } from "react";
import toastr from "toastr";
import moment from "moment/moment";
import Table from "./Table";
import Filters from "./Filters";
import CardSelector from "../../CardSelector";
import { getRequest } from "../../../../utils/httpRequest";
import { Transaction } from "./Types";

interface Props {
  transactions: Transaction[];
  cardId: string;
  cards?: any[];
}

interface State {
  filters: {
    startDate: any;
    endDate: any;
  };
  transactions: Transaction[];
  loading: boolean;
  selectedCardId: string;
}

class List extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      filters: {
        startDate: moment().subtract(2, "months").startOf("month"),
        endDate: moment(),
      },
      transactions: [],
      loading: true,
      selectedCardId: props.cardId,
    };
  }

  componentDidMount() {
    this.getTransactions();
  }

  onSelectFilter = (key, value) => {
    const { filters } = this.state;

    const updatedFilters = { ...filters, [key]: value };

    this.setState({ filters: updatedFilters });
  };
  getTransactions = (e = null) => {
    e?.preventDefault();

    this.setState({ loading: true });

    const {
      filters: { startDate, endDate },
    } = this.state;

    const url = `/api/v1/cards/${
      this.props.cardId
    }/transactions?start_date=${startDate.format(
      "YYYY-MM-DD"
    )}&end_date=${endDate.format("YYYY-MM-DD")}`;

    getRequest(url)
      .then((response) => {
        this.setState({
          transactions: response,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false, transactions: [] });
      });
  };
  handleCardChange = (cardId: string) => {
    this.setState({ selectedCardId: cardId, loading: true });
    window.location.href = `/cards/${cardId}/activities`;
  };

  render() {
    const { cardId, cards } = this.props;
    const { transactions, filters, loading, selectedCardId } = this.state;

    const selectedCard = cards?.find((card) => card.id === selectedCardId);

    return (
      <div className="account-activity">
        {cards && cards?.length > 0 && (
          <div className="mb-3">
            <CardSelector
              cards={cards || []}
              currentCardId={selectedCardId}
              onCardChange={this.handleCardChange}
            />
          </div>
        )}
        <Filters
          filters={filters}
          getTransactions={this.getTransactions}
          onSelectFilter={this.onSelectFilter}
        />
        <Table
          transactions={transactions}
          loading={loading}
          cardType={selectedCard?.card_type}
        />
      </div>
    );
  }
}

export default List;
